import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {SharedImports} from '@shared/shared-imports';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {MessageService} from 'primeng/api';
import {ContextService} from '@services/context.service';
import {OrganizationRegistrationModel} from '@app/models/organizations.model';
import {SelfRegistrationModel} from '@app/models/user-registration.model';
import {Subject} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {UserAccountService} from '@services/user-account.service';

@Component({
  templateUrl: './email-password-reset-request.component.html',
  styleUrls: ['./email-password-reset-request.component.scss'],
  imports: [SharedImports]
})
export class EmailPasswordResetRequestComponent implements OnInit, OnDestroy {
  mainForm: FormGroup;
  logo: string;
  isSaving: boolean = false;
  tenantName: string;
  organizationGuid: string;
  // isLegacy: boolean = false;
  isProcessed: boolean = false;
  @Output() next = new EventEmitter<any>();
  @Output() updateData = new EventEmitter<any>();
  @Input() registrationProfile: SelfRegistrationModel;
  @Input() campaignId: number;
  @Input() organizationDetails: OrganizationRegistrationModel;

  private ngUnsubscribe = new Subject();

  constructor(private formBuilder: FormBuilder, public contextService: ContextService,
              private messageService: MessageService, private route: ActivatedRoute, private userAccountService: UserAccountService) {
    this.mainForm = this.formBuilder.group({
      email: new FormControl(null, [Validators.required, Validators.email]),
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe({
      next: (params) => {
        // get the query parameters
        if (params && params.tenant) {
          this.tenantName = params.tenant;
        } else {
          this.tenantName = this.contextService.contextObject.tenantName;
        }
        this.organizationGuid = this.route.snapshot.paramMap.get('id');
        this.logo = this.contextService.contextObject.tenantLogo;
      }
    });


  }

  validateEmail() {
    const tempModelData = {
      EmailAddress: this.mainForm.get('email').value,
    };
    this.isSaving = true;
    this.userAccountService.requestPasswordReset(tempModelData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res) => {
          this.messageService.add({severity: 'success', summary: 'Success', detail: 'Your password reset email has been sent.'});
          this.next.emit();
          this.isSaving = false;
          this.isProcessed = true;
        }, error: (e) => {
          console.log(e);
          if (e?.error?.Message) {
            this.messageService.add({severity: 'error', summary: 'Error', detail: e.error.Message.replace('UM: ', ''), life: 5000});
          } else {
            this.messageService.add({severity: 'error', summary: 'Error', detail: 'Our apologies... An error occurred. Please try again and let us know if it continues. Thank you!'});
          }
          this.isSaving = false;
        }
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }
}
